/* eslint-disable */
import { ObservableFactory } from "../../react-rxjs";
import { IDataSource } from "./types/IDataSource";
import { IDimension } from "./types/IDimension";
import { IMeasure } from "./types/IMeasure";
import { IField } from "./types/IField";
import { BulkExportFormatte } from "./types/BulkExportFormatte";
import { combineLatest } from "rxjs";

export class BulkExportContext {
  constructor() {
    this.dimensions$.subscribe((dimensions) => {
      const configuration = dimensions.find(x => x.id === "configuration" && x.hierarchy === "configuration.virtual");
      if (configuration?.selection) {
        const filter = x => x.includes('Measure');
        const measures = configuration.selection.filter(filter);
        const fields = configuration.selection.filter(x => !filter(x));
        this.setSelectedMeasures(measures);
        this.setSelectedFields(fields);
      }
    });

    combineLatest([
      this.dataSource$,
      this.dimensions$,
      this.email$,
      this.formatte$,
      this.selectedMeasures$,
      this.selectedFields$,
      this.measures$,
      this.fields$,
    ]).subscribe(() => this.setBeenSent(false));
  }

  private _beenSent$ = ObservableFactory.createBehaviorSubject<boolean>(false);
  public get beenSent$() { return this._beenSent$[0]!; }
  public get setBeenSent() { return this._beenSent$[1]!; }

  private _loading$ = ObservableFactory.createBehaviorSubject<boolean>(false);
  public get loading$() { return this._loading$[0]!; }
  public get setLoading() { return this._loading$[1]!; }

  private _buildDataSource$ = ObservableFactory.createBehaviorSubject<IDataSource | undefined>(undefined);
  public get buildDataSource$() { return this._buildDataSource$[0]!; }
  public get setBuildDataSource() { return this._buildDataSource$[1]!; }

  private _email$ = ObservableFactory.createBehaviorSubject<string | undefined>(undefined);
  public get email$() { return this._email$[0]!; }
  public get setEmail() { return this._email$[1]!; }
  
  private _formatte$ = ObservableFactory.createBehaviorSubject<BulkExportFormatte>(BulkExportFormatte.Default);
  public get formatte$() { return this._formatte$[0]!; }
  public get setFormatte() { return this._formatte$[1]!; }

  private _dataSource$ = ObservableFactory.createBehaviorSubject<IDataSource| undefined>(undefined);
  public get dataSource$() { return this._dataSource$[0]!; }
  public get setDataSource() { return this._dataSource$[1]!; }

  private _dataSources$ = ObservableFactory.createBehaviorSubject<IDataSource[]>([]);
  public get dataSources$() { return this._dataSources$[0]!; }
  public get setDataSources() { return this._dataSources$[1]!; }

  private _dimensions$ = ObservableFactory.createBehaviorSubject<IDimension[]>([]);
  public get dimensions$() { return this._dimensions$[0]!; }
  public get setDimensions() { return this._dimensions$[1]!; }

  private _measures$ = ObservableFactory.createBehaviorSubject<IMeasure[]>([]);
  public get measures$() { return this._measures$[0]!; }
  public get setMeasures() { return this._measures$[1]!; }

  private _fields$ = ObservableFactory.createBehaviorSubject<IField[]>([]);
  public get fields$() { return this._fields$[0]!; }
  public get setFields() { return this._fields$[1]!; }

  private _selectedMeasures$ = ObservableFactory.createBehaviorSubject<string[]>([]);
  public get selectedMeasures$() { return this._selectedMeasures$[0]!; }
  public get setSelectedMeasures() { return this._selectedMeasures$[1]!; }

  private _selectedFields$ = ObservableFactory.createBehaviorSubject<string[]>([]);
  public get selectedFields$() { return this._selectedFields$[0]!; }
  public get setSelectedFields() { return this._selectedFields$[1]!; }  
}